import styles from './Forms.module.css';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { IoMdTrash } from 'react-icons/io';
import Dynamic from '../../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../../components/PaginationTable/PaginationTable';

import Action from '../../../components/Action/Action';

import CopyRight from '../../../components/CopyRight/CopyRight';

const data = [
  {
    _id: '1',
    title: 'Title 1',
    date: '25/04/2025',
    status: 'Active',
  },
  {
    _id: '2',
    title: 'Title 1',
    date: '25/04/2025',
    status: 'Active',
  },
  {
    _id: '3',
    title: 'Title 1',
    date: '25/04/2025',
    status: 'Active',
  },
];

function Forms() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handlecreateform = () => {
    dispatch(openModal('addFeePlan'));
  };
  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        title: <span className={styles.greyText}>{item.title}</span>,
        date: <span className={styles.greyText}>{item.date}</span>,
        status: <span className={styles.greyText}>{item.status}</span>,
        action: <IoMdTrash color={'red'} size={24} />,
      };
    });
  };

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: 'Send Invite',
      onclick: () => {
        console.log('send invite');
      },
    },
    {
      label: 'Update Rooms',
      onclick: () => {
        dispatch(openModal('updateRoom'));
      },
    },
    {
      label: 'Update Status',
      onclick: () => {
        dispatch(openModal('statusUpdate'));
      },
    },
    {
      label: 'Update Groups',
      onclick: () => {
        dispatch(openModal('updateGroups'));
      },
    },
    {
      label: 'Transfer Student',
      onclick: () => {
        dispatch(openModal('TransferStudent'));
      },
    },
    {
      label: 'Create Folder',
      onclick: () => {
        dispatch(openModal('createFolder'));
      },
    },
  ];

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Title', accessor: 'title' },
    { title: 'Date', accessor: 'date' },
    { title: 'Status', accessor: 'status' },
    { title: 'Action', accessor: 'action' },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search by title"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <div className={styles.filters}>
              <Dropdown
                label="Search by"
                options={['Name', 'Status', 'Label', 'Program']}
              />
              <Dropdown
                label="All Process"
                options={['Live', 'Inactive', 'Draft']}
              />
            </div>
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default Forms;
